import { render, staticRenderFns } from "./AddSynthetical.vue?vue&type=template&id=0ce4e6e9&scoped=true&"
import script from "./AddSynthetical.vue?vue&type=script&lang=js&"
export * from "./AddSynthetical.vue?vue&type=script&lang=js&"
import style0 from "./AddSynthetical.vue?vue&type=style&index=0&id=0ce4e6e9&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce4e6e9",
  null
  
)

export default component.exports